import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

export const schema = Joi.object().keys({
	student_id_list: Joi.array().allow(null),
	class_id_list: Joi.array().allow(null),
  start_date: Joi.string().allow('').allow(null),
  end_date: Joi.string().allow('').allow(null),
  transaction_number: Joi.string().allow('').allow(null),
  paging_or_not: Joi.number().integer(),
  amount_per_page: Joi.number().integer(),
  page_number: Joi.number().integer()
});

export default function getTradeRecord(schoolId, tradeInfo) {
	if (!schoolId) {
		throw "mssing a school ID";
	}

  let validateResult = Joi.validate(tradeInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': `/search_trade_list/${schoolId}/`,
		'method': 'POST',
		'data': JSON.stringify(tradeInfo),
		'token': localStorage.getItem('token')})
     .then((res) => {

       //
       // the backend returns { result: '' } when transaction_number is not found
       // to keep the data integrity, we have added dummy result that includes
       // an empty array for result_list and some number such as total_record_amount etc...
       //
       if (typeof res.data.result == 'string' && res.data.result.indexOf('no such transaction_number in database') > -1) {
         resolve({
           amount_per_page: tradeInfo.amount_per_page,
           current_page_number: tradeInfo.page_number,
           total_record_amount: 0,
           result_list: [],
         });
       } else {
         resolve(res.data);
       }
    })
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/school/getTradeRecord.js